var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreensaverLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241.58 142.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#026634;}.cls-2{fill:#3a3e37;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.23,10h7.56V33.32h-6.2V20.56L120.79,41.9,110,20.64V33.32h-6.2V10h7.77l9.23,20.51ZM120.79,6.4l2.82,9-2.82-2.07L118,15.35ZM93.78,0V59l7.15-6.27,5.22,5.32,14.64-12.86,14.64,12.86,5.22-5.32L147.8,59V0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.44 86.11 13.87 102.87 6.3 86.11 0 86.11 0 110.2 5.03 110.2 5.03 94.75 12.08 110.2 15.45 110.2 22.55 94.68 22.55 110.2 27.57 110.2 27.57 86.11 21.44 86.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.81,100.57h6L47.8,92.68Zm5.37-14.46,9.67,24.09H54.44l-2-5.19H43.22l-2,5.19h-5.3L45.6,86.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.9,100.64V86.11h5.23v14.25c0,3.24,1.58,5.27,4.44,5.27s4.44-2,4.44-5.27V86.11h5.23v14.53c0,6.09-3.65,10-9.67,10s-9.67-3.92-9.67-10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.66,97.12h2.92c2.07,0,3.58-1.2,3.58-3.2s-1.51-3.16-3.58-3.16h-2.92Zm0,13.08H96.53V86.11h8c5.19,0,8.81,2.79,8.81,7.71a7.24,7.24,0,0,1-5,7l6.65,9.43H109L103,101.39h-1.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.44,
    y: 86.11,
    width: 5.2,
    height: 24.09
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "139.23 86.11 153.41 86.11 153.41 90.79 144.4 90.79 144.4 95.68 152.62 95.68 152.62 100.22 144.4 100.22 144.4 105.52 153.48 105.52 153.48 110.2 139.23 110.2 139.23 86.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "184.63 86.11 184.63 110.2 179.47 110.2 168.14 94.3 168.14 110.2 163.12 110.2 163.12 86.11 168.38 86.11 179.6 102.08 179.6 86.11 184.63 86.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.74 86.11 216.74 110.2 211.57 110.2 200.25 94.3 200.25 110.2 195.22 110.2 195.22 86.11 200.49 86.11 211.71 102.08 211.71 86.11 216.74 86.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "227.33 86.11 227.33 110.2 241.58 110.2 241.58 105.52 232.49 105.52 232.49 100.22 240.72 100.22 240.72 95.68 232.49 95.68 232.49 90.79 241.51 90.79 241.51 86.11 227.33 86.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.27,126.16A6.71,6.71,0,0,0,40,122.54a7.63,7.63,0,0,0,0,15.25,6.18,6.18,0,0,0,6.33-4.65h-7v-4.33H52v1.92A11.63,11.63,0,0,1,40,142.64a12.5,12.5,0,1,1,0-25A11.87,11.87,0,0,1,51,123.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.16,132.56h6.06l-3.07-7.88Zm5.37-14.46,9.67,24.1H76.8l-2-5.2H65.57l-2,5.2h-5.3L68,118.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.69 118.1 95.69 137.34 104.08 137.34 104.08 142.19 90.52 142.19 90.52 118.1 95.69 118.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 112.86,
    y: 118.1,
    width: 5.2,
    height: 24.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.67,137.86c2.2,0,3.65-1,3.65-3s-1.48-3-3.65-3h-4v6ZM137,127.71c1.79,0,3.09-.93,3.09-2.66s-1.3-2.65-3.09-2.65h-3.24v5.31Zm-8.3-9.61h8.81c4.44,0,7.64,2.41,7.64,6.51a5.08,5.08,0,0,1-2.82,4.71,5.89,5.89,0,0,1,4.27,5.82c0,4.41-3.3,7.06-8.57,7.06h-9.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 155.91,
    y: 118.1,
    width: 5.2,
    height: 24.09
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.7 118.1 185.88 118.1 185.88 122.78 176.87 122.78 176.87 127.67 185.09 127.67 185.09 132.21 176.87 132.21 176.87 137.51 185.95 137.51 185.95 142.19 171.7 142.19 171.7 118.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.71,129.12h2.93c2.06,0,3.58-1.21,3.58-3.2s-1.52-3.17-3.58-3.17h-2.93Zm0,13.08h-5.13V118.1h8c5.2,0,8.82,2.79,8.82,7.71a7.24,7.24,0,0,1-5,6.95l6.64,9.44H208l-5.92-8.82h-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.58,78.32A2.63,2.63,0,0,0,23.82,78v-.9a2.22,2.22,0,0,1-1.2.35,1.77,1.77,0,0,1,0-3.53,2.14,2.14,0,0,1,1.19.35v-.89a2.54,2.54,0,0,0-1.22-.33A2.6,2.6,0,0,0,20,75.69,2.54,2.54,0,0,0,22.58,78.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.52,73.05a2.64,2.64,0,1,0,2.66,2.64A2.65,2.65,0,0,0,31.52,73.05Zm0,4.41a1.78,1.78,0,1,1,1.74-1.77A1.74,1.74,0,0,1,31.52,77.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.4 78.22 45.4 73.15 44.26 73.15 42.5 77.03 40.75 73.15 39.57 73.15 39.57 78.22 40.42 78.22 40.42 74.35 42.19 78.22 42.77 78.22 44.54 74.34 44.54 78.22 45.4 78.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.88 78.22 56.88 73.15 55.73 73.15 53.98 77.03 52.22 73.15 51.04 73.15 51.04 78.22 51.9 78.22 51.9 74.35 53.66 78.22 54.24 78.22 56.02 74.34 56.02 78.22 56.88 78.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.47,73.15h-.91v3c0,.81-.41,1.29-1.1,1.29s-1.11-.49-1.11-1.29v-3h-.9v3.08a2,2,0,1,0,4,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.53 78.22 76.53 73.15 75.68 73.15 75.68 76.95 73.01 73.15 72.04 73.15 72.04 78.22 72.89 78.22 72.89 74.44 75.59 78.22 76.53 78.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.28,77.07l.45,1.15h.92l-2-5.07h-.83l-2,5.07h.89l.45-1.15Zm-1.1-2.95L85,76.34H83.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.58,73.15h-.9v3c0,.81-.41,1.29-1.1,1.29s-1.11-.49-1.11-1.29v-3h-.9v3.08a2,2,0,1,0,4,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "104.5 73.15 100.81 73.15 100.81 73.96 102.21 73.96 102.21 78.22 103.11 78.22 103.11 73.96 104.5 73.96 104.5 73.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.47 72.49 112.23 71.63 111.43 71.63 110.84 72.49 111.47 72.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.42 76.02 112.42 75.27 110.61 75.27 110.61 73.93 112.6 73.93 112.6 73.15 109.72 73.15 109.72 78.22 112.61 78.22 112.61 77.44 110.61 77.44 110.61 76.02 112.42 76.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.74,73.15h-1.67v5.07h1.67a2.54,2.54,0,1,0,0-5.07Zm0,4.25H125V74h.75a1.72,1.72,0,0,1,0,3.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.41 76.02 136.41 75.27 134.6 75.27 134.6 73.93 136.59 73.93 136.59 73.15 133.71 73.15 133.71 78.22 136.6 78.22 136.6 77.44 134.6 77.44 134.6 76.02 136.41 76.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.43,78.32a2.63,2.63,0,0,0,1.24-.32v-.9a2.22,2.22,0,0,1-1.2.35,1.77,1.77,0,0,1,0-3.53,2.14,2.14,0,0,1,1.19.35v-.89a2.54,2.54,0,0,0-1.22-.33,2.6,2.6,0,0,0-2.63,2.64A2.54,2.54,0,0,0,150.43,78.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.37,73.05A2.64,2.64,0,1,0,162,75.69,2.65,2.65,0,0,0,159.37,73.05Zm0,4.41a1.78,1.78,0,1,1,1.74-1.77A1.74,1.74,0,0,1,159.37,77.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "173.25 78.22 173.25 73.15 172.1 73.15 170.35 77.03 168.6 73.15 167.42 73.15 167.42 78.22 168.27 78.22 168.27 74.35 170.04 78.22 170.62 78.22 172.39 74.34 172.39 78.22 173.25 78.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "184.73 78.22 184.73 73.15 183.58 73.15 181.83 77.03 180.07 73.15 178.89 73.15 178.89 78.22 179.75 78.22 179.75 74.35 181.51 78.22 182.1 78.22 183.87 74.34 183.87 78.22 184.73 78.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.32,73.15h-.91v3c0,.8-.42,1.29-1.1,1.29s-1.11-.49-1.11-1.29v-3h-.9v3.08a2,2,0,1,0,4,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "204.38 78.22 204.38 73.15 203.53 73.15 203.53 76.95 200.86 73.15 199.89 73.15 199.89 78.22 200.75 78.22 200.75 74.44 203.44 78.22 204.38 78.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "212.73 76.02 212.73 75.27 210.91 75.27 210.91 73.93 212.9 73.93 212.9 73.15 210.03 73.15 210.03 78.22 212.92 78.22 212.92 77.44 210.91 77.44 210.91 76.02 212.73 76.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.87,78.32a1.62,1.62,0,0,0,1.75-1.55c0-.66-.38-1.1-1.18-1.41l-.69-.26c-.26-.1-.6-.27-.6-.65s.29-.59.72-.59a1,1,0,0,1,.89.58l.73-.42a1.84,1.84,0,0,0-1.64-1,1.47,1.47,0,0,0-1.62,1.47c0,.66.39,1.11,1.19,1.4l.64.23c.27.1.63.28.63.69s-.33.66-.81.66a1.22,1.22,0,0,1-1.08-.71l-.76.4A1.93,1.93,0,0,0,219.87,78.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreensaverLogo);
export default __webpack_public_path__ + "static/media/screensaver_logo.dc42f49d17d820373d1ea3170d10e588.svg";
export { ForwardRef as ReactComponent };